import React, { PropsWithChildren } from 'react';

import { Layout } from 'ds';

import { BOTTOM_SHEET_PADDING_TOP, MOBILE_PROGRESS_FOOTER_HEIGHT } from './constants';

interface Props {}

const ServicesRequestBottomSheet: React.FC<PropsWithChildren<Props>> = ({ children }) => {
  return (
    <Layout
      position="fixed"
      bottom={0}
      color="white"
      width="100%"
      paddingTop={BOTTOM_SHEET_PADDING_TOP}
      borderTopLeftRadius={16}
      borderTopRightRadius={16}
      paddingBottom={MOBILE_PROGRESS_FOOTER_HEIGHT}
      __className="ServicesRequestBottomSheet"
    >
      {children}
    </Layout>
  );
};

export default ServicesRequestBottomSheet;
